const contentfulLoader = ({
  src,
  quality,
}: {
  src: string;
  quality?: number;
}) => {
  const cleanSrc = src.startsWith("//") ? `https:${src}` : src;
  return `${cleanSrc}?q=${quality || 75}`;
};

export default function ContentfulImage({
  src,
  alt = "Contentful image",
  className = "",
  quality = 75,
}: {
  src: string;
  alt?: string;
  className?: string;
  quality?: number;
}) {
  const imageUrl = contentfulLoader({ src, quality });

  return (
    <div className="relative overflow-hidden">
      <img src={imageUrl} alt={alt} className={className} loading="lazy" />
    </div>
  );
}
